import PayloadStrategy from "./PayloadStrategy";
import moment from "moment";
import DateUtils from "../helpers/DateUtils";

export default class AlarmSpeed extends PayloadStrategy {
	constructor({
		company_id,
		created_at,
		days,
		email,
		end_date,
		end_hour,
		init_date,
		init_hour,
		id,
		name,
		resource_id,
		language,
		speed,
	}) {
		super();
		this.speed = speed || 0;
		this.company_id = company_id || 0;
		this.email = email || [];
		this.days = days || [];
		this.end_date = end_date ? moment(end_date).format() : new Date();
		this.end_hour = end_hour || "";
		this.init_date = init_date ? moment(init_date).format() : new Date();
		this.init_hour = init_hour || "";
		this.id = id || null;
		this.name = name || "";
		this.resource_id = resource_id || [];
		this.language = language || "es_CO";
		this.created_at = created_at || "";
	}

	getResourceId() {
		return this.resource_id;
	}

	setResourceId(resource_id) {
		this.resource_id = resource_id.map((item) => item.key);
		return this;
	}

	/**
	 * Returns an object representing the payload to create a Warehouse.
	 * This method is an implementation of the abstract method from the parent class.
	 * @returns {Object} The payload object.
	 */
	payloadToCreate() {
		const payload = {
			speed: this.speed,
			name: this.name,
			email: this.email,
			days: this.days,
			end_date: DateUtils.formatDate(this.end_date, "YYYY-MM-DD"),
			end_hour: this.end_hour,
			init_date: DateUtils.formatDate(this.init_date, "YYYY-MM-DD"),
			init_hour: this.init_hour,
			resource_id: this.resource_id,
			language: this.language,
		};

		return payload;
	}

	/**
	 * Returns an object representing the payload to update a Warehouse.
	 * This method is an implementation of the abstract method from the parent class.
	 * @returns
	 */
	payloadToUpdate() {
		return {
			speed: this.speed,
			name: this.name,
			email: this.email,
			days: this.days,
			end_date: DateUtils.formatDate(this.end_date, "YYYY-MM-DD"),
			end_hour: this.end_hour,
			init_date: DateUtils.formatDate(this.init_date, "YYYY-MM-DD"),
			init_hour: this.init_hour,
			resource_id: this.resource_id,
			language: this.language,
		};
	}
	payloadToFetch() {
		return [
			"key",
			"speed",
			"name",
			"email",
			"days",
			"end_date",
			"end_hour",
			"init_date",
			"init_hour",
			"resource_id",
			"language",
		];
	}
}
